import onetime from "@-/com.npmjs.onetime";
import type { HskVersionKey } from "@-/dev.improve.haniverse.lib.morpheme.grade.hsk";

import hskLevelTotalsData from "#hsk-level-totals.gen.json" with { type: "json" };

/**
 * Count of graphemes per HSK version and level — the denominator the stats page
 * shows for HSK progress. Derived purely from the static dataset, so the values
 * are precomputed at build time into `hsk-level-totals.gen.json` (regenerated by
 * the static-DB build) instead of recomputed on-device by scanning the whole
 * grapheme table on every stats load. This module is the hand-written, typed
 * wrapper around that generated JSON.
 */
export type HskLevelTotals = Readonly<Record<HskVersionKey, ReadonlyMap<number, number>>>;

function toLevelMap(levels: Readonly<Record<string, number>>): ReadonlyMap<number, number> {
  return new Map(Object.entries(levels).map(([level, total]) => [Number(level), total]));
}

export const getHskLevelTotals = onetime((): HskLevelTotals => ({
  hsk2: toLevelMap(hskLevelTotalsData.hsk2),
  hsk2026: toLevelMap(hskLevelTotalsData.hsk2026),
  hsk3: toLevelMap(hskLevelTotalsData.hsk3),
}));
